import * as Scrivito from "scrivito";
import { sectionColors } from "^/config/attributeConsts";

const BentoGridWidget = Scrivito.provideWidgetClass("BentoItemWidget", {
  onlyInside: "BentoGridWidget",
  attributes: {
    content: "widgetlist",
    wideStyle: "boolean",
    tallStyle: "boolean",
    target: "link",
    boxStyle: [
      "enum",
      {
        values: sectionColors,
      },
    ],
  },
  extractTextAttributes: ["content"],
});

export default BentoGridWidget;
